// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"111":"0c27449a","896":"4b4e1b5b"}[chunkId] + ".css";
};